import { Spin } from "antd";
import DocumentWrapper from "./components/DocumentWrapper";
import { useEffect, useRef, useState } from "react";
import NoResults from "../../../components/shared/NoResults";
import getQuotation from "../../../services/getQuotation";
import { useParams } from "react-router";
import ReactToPrint from "react-to-print";
import { AiOutlinePrinter } from "react-icons/ai";

export default function QuotationPannel() {
  const docRef = useRef(null);
  const [isLoading, setLoading] = useState(false);
  const [quotation, setQuotation] = useState<any>([]);

  const { id } = useParams();

  const handleFetchQuotation = async () => {
    const response = await getQuotation(id);
    setQuotation(response);
  };

  useEffect(() => {
    handleFetchQuotation();
  }, []);

  const getTotalDue = () => {
    let total = 0;

    quotation?.quoteitems?.forEach((item: any) => {
      total = total + item.net_total;
    });
    return total;
  };

  return (
    <>
      <div className="flex flex-row justify-center items-center  p-4  mt-4">
        <div className="border border-toyota p-4 rounded-md">
          <ReactToPrint
            trigger={() => {
              return (
                <button className="flex justify-center items-center focus:outline-none hover:text-red-500 mr-2 text-3xl">
                  <AiOutlinePrinter className="mr-2" /> Download
                </button>
              );
            }}
            content={() => docRef.current}
            documentTitle={`Quotation`}
          />
        </div>
      </div>
      <div className="flex flex-row bg-whitish  justify-center items-start overflow-auto">
        <div className="bg-white px-4">
          {isLoading ? (
            <div className="">
              <Spin />
            </div>
          ) : (
            <div className="">
              {quotation?.quoteitems?.length === 0 ? (
                <div className="flex justify-center items-center mt-16">
                  <NoResults />
                </div>
              ) : (
                <div className="book" ref={docRef}>
                  {quotation?.quoteitems?.map((page: any, index: number) => (
                    <div className="page" key={index}>
                      <div className="subpage">
                        <DocumentWrapper
                          statements={page}
                          selected={quotation}
                          pageno={index + 1}
                          pages={quotation?.quoteitems?.length}
                          getTotalDue={getTotalDue}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
